import { Button, Card, CardContent, Dialog, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import { useContext, useEffect } from "react";
import { CalculationVisualizerContext } from "../../../Context/CalculationVisualizerContextProvider";
import { useState } from "react";
import { getOptionAttributes, setCustomCalculations } from "../../../Actions";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { Delete } from "@material-ui/icons";

function OperandInput(props) {
  const updateOperand = (value, attribute, formula, inputAttribute, operandType) => {
    const tempOperand = { ...props.operand };
    const operandTypeForCheck = operandType || tempOperand.type;

    if (tempOperand.type && operandTypeForCheck !== tempOperand.type && props.nodeType === "condition") {
      delete tempOperand.value;
      delete tempOperand.attribute;
      delete tempOperand.formula;
      delete tempOperand.inputAttribute;
    } 
    
    if (tempOperand.type && operandTypeForCheck !== tempOperand.type && props.nodeType === "formula") {
      delete tempOperand.value;
      delete tempOperand.attribute;
    }

    tempOperand.value = value ?? tempOperand.value ?? undefined;
    tempOperand.attribute = attribute || tempOperand.attribute || undefined;
    tempOperand.formula = formula || tempOperand.formula || undefined;
    tempOperand.inputAttribute = inputAttribute || tempOperand.inputAttribute || undefined;
    tempOperand.type = operandTypeForCheck || "manual";
    tempOperand.next = props.operand?.next || null;

    props.updateOperand({ ...tempOperand });
  }

  useEffect(() => {
    if (props.operand?.type) return;

    let operandType = "manual";

    const hasAtleastTwoValues = [props.operand?.value, props.operand?.attribute, props.operand?.inputAttribute].filter(o => !!o)?.length >= 2

    if (props.nodeType === "condition" && (props.operand?.formula || hasAtleastTwoValues)) {
      operandType = "formula";
    } else if (props.operand?.attribute) {
      operandType = "attribute";
    }

    updateOperand(undefined, undefined, undefined, undefined, operandType);
  }, [props.operand.type]);

  return (
    <Grid 
      container 
      spacing={2} 
      style={{ 
        marginTop: props.nodeType === 'condition' ? "10px" : "0px", 
        marginBottom: props.nodeType === 'condition' ? "10px" : "0px",
        border: props.nodeType === 'condition' ? "2px solid #00000017" : "0px", 
        borderRadius: "5px" 
      }}
    >
      <Grid item xs={10}>
        <ToggleButtonGroup
          value={props.operand?.type || "manual"}
          exclusive
          size='small'
          onChange={(e, newValue) => {
            if (!newValue) return;

            updateOperand(undefined, undefined, undefined, undefined, newValue);
          }}
          aria-label="text alignment"
          style={{display: "inline-block"}}
        >
          <ToggleButton value='manual' aria-label="manual value" style={props.operand?.type === "manual" ? {backgroundColor: "#142E3E", color: "#28C4FC"} : {backgroundColor: "#00000017", color: "initial"}}>
            Manual Value
          </ToggleButton>
          <ToggleButton value='attribute' aria-label="attribute value" style={props.operand?.type === "attribute" ? {backgroundColor: "#142E3E", color: "#28C4FC"} : {backgroundColor: "#00000017", color: "initial"}}>
            Attribute
          </ToggleButton>
          { props.nodeType === "condition" && (
            <ToggleButton value='formula' aria-label="formula" style={props.operand?.type === "formula" ? {backgroundColor: "#142E3E", color: "#28C4FC"} : {backgroundColor: "#00000017", color: "initial"}}>
              Formula
            </ToggleButton>
          )}
        </ToggleButtonGroup>
      </Grid>
      { props.nodeType === "condition" && props.canDelete ? (
          <Grid item xs={2} style={{ textAlign: "right" }}>
            <IconButton style={{color: "#f44336"}} onClick={() => props.deleteOperand()}><Delete /></IconButton>
          </Grid>
        ) : undefined 
      }
      { ["attribute", "formula"].includes(props.operand?.type) && props.attributes?.length ? ( 
          <Grid item xs={12}>
            <FormControl fullWidth size="small" variant="filled">
              <InputLabel shrink id="option-list-label">Selected Option Attribute</InputLabel>
              <Select
                value={props.operand?.attribute || ""}
                displayEmpty
                id="option-list-label"
                onChange={(e) => updateOperand(undefined, e.target.value, undefined, undefined, undefined)}
              >
                <MenuItem value="" disabled>Please select one of the following</MenuItem>
                { 
                  props.attributes.map((a) => {
                    return <MenuItem key={a} value={a}>{a}</MenuItem>
                  })
                }
              </Select>
            </FormControl>
          </Grid>
        ) : undefined
      }
      { ["manual", "formula"].includes(props.operand?.type) ? (
          <Grid item xs={12}>
            { props.nodeType === "condition" ? (
              <TextField
                label="Manual Value"
                fullWidth
                size="small"
                variant="filled"
                value={props.operand?.value || ""}
                onChange={(e) => updateOperand(e.target.value, undefined, undefined, undefined, undefined)}
              />
            ) : (
              <TextField
                label="Manual Value"
                fullWidth
                size="small"
                type="number"
                inputProps={{ min: 0 }}
                variant="filled"
                value={props.operand?.value || ""}
                error={Number(props.operand?.value) < 0}
                helperText={Number(props.operand?.value) < 0 ? "Value must be greater than 0" : ""}
                onChange={(e) => updateOperand(e.target.value, undefined, undefined, undefined, undefined)}
              />
            )}
          </Grid> 
        ) : undefined 
      }
      { ["formula"].includes(props.operand?.type) ? (
          <>
            <Grid item xs={12}>
              <FormControl fullWidth size="small" variant="filled">
                <InputLabel shrink id="option-list-label">Selected Input Attribute</InputLabel>
                <Select
                  value={props.operand?.inputAttribute || ""}
                  displayEmpty
                  id="option-list-label"
                  onChange={(e) => updateOperand(undefined, undefined, undefined, e.target.value, undefined)}
                >
                  <MenuItem value="" disabled>Please select one of the following</MenuItem>
                  <MenuItem value="current">Current</MenuItem>
                  <MenuItem value="price">Price</MenuItem>
                  <MenuItem value="cost">Cost</MenuItem>
                  <MenuItem value="loadedCost">Loaded Cost</MenuItem>
                  <MenuItem value="quantity">Quantity</MenuItem>
                  <MenuItem value="selectedQuantity">Selected Quantity</MenuItem>
                  <MenuItem value="currGroup">Current Group</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth size="small" variant="filled">
                <InputLabel shrink id="option-list-label">Selected Formula</InputLabel>
                <Select
                  value={props.operand?.formula || ""}
                  displayEmpty
                  id="option-list-label"
                  onChange={(e) => updateOperand(undefined, undefined, e.target.value, undefined, undefined)}
                >
                  <MenuItem value="" disabled>Please select one of the following</MenuItem>
                  <MenuItem value="add">Add</MenuItem>
                  <MenuItem value="subtract">Subtract</MenuItem>
                  <MenuItem value="divide">Divide</MenuItem>
                  <MenuItem value="multiply">Multiply</MenuItem>
                  <MenuItem value="percentageIncrease">Percentage Increase</MenuItem>
                  <MenuItem value="percentageDecrease">Percentage Decrease</MenuItem>
                  <MenuItem value="profitMargin">Profit Margin</MenuItem>
                  <MenuItem value="retailRoundUp">Retail Round Up</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </> 
        ) : undefined 
      }
    </Grid>
  )
} 

function FormulaForm(props) {
  const { selectedNode, setSelectedNode } = useContext(CalculationVisualizerContext);

  const updateNodeData = (selectedFormula, selectedInputAttribute, operand) => {
    const tempNodeData = { 
      ...selectedNode,
      formula: selectedFormula || selectedNode.formula || "",
      inputAttribute: selectedInputAttribute || selectedNode.inputAttribute || "current",
      operand: operand || selectedNode.operand || null,
    };

    setSelectedNode({ ...tempNodeData });
  };

  return (
    <Grid item xs={12}>
      <Typography variant="h6" style={{ marginTop: "10px" }}>Formula Details</Typography>
      <Grid container spacing={2} style={{ marginTop: "10px", border: "2px solid #00000017", borderRadius: "5px" }}>
        <Grid item xs={12}>
          <FormControl fullWidth size="small" variant="filled">
            <InputLabel shrink id="option-list-label">Selected Formula</InputLabel>
            <Select
              value={selectedNode.formula ?? ""}
              displayEmpty
              id="option-list-label"
              onChange={(e) => updateNodeData(e.target.value, undefined, undefined)}
            >
              <MenuItem value="" disabled>Please select one of the following</MenuItem>
              <MenuItem value="add">Add</MenuItem>
              <MenuItem value="subtract">Subtract</MenuItem>
              <MenuItem value="divide">Divide</MenuItem>
              <MenuItem value="multiply">Multiply</MenuItem>
              <MenuItem value="percentageIncrease">Percentage Increase</MenuItem>
              <MenuItem value="percentageDecrease">Percentage Decrease</MenuItem>
              <MenuItem value="profitMargin">Profit Margin</MenuItem>
              <MenuItem value="retailRoundUp">Retail Round Up</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">Input</Typography>
          <FormControl fullWidth size="small" variant="filled">
            <InputLabel shrink id="option-list-label">Selected Input Attribute</InputLabel>
            <Select
              value={selectedNode.inputAttribute ?? ""}
              displayEmpty
              id="option-list-label"
              onChange={(e) => updateNodeData(undefined, e.target.value, undefined)}
            >
              <MenuItem value="" disabled>Please select one of the following</MenuItem>
              <MenuItem value="current">Current</MenuItem>
              <MenuItem value="price">Price</MenuItem>
              <MenuItem value="cost">Cost</MenuItem>
              <MenuItem value="loadedCost">Loaded Cost</MenuItem>
              <MenuItem value="quantity">Quantity</MenuItem>
              <MenuItem value="selectedQuantity">Selected Quantity</MenuItem>
              <MenuItem value="currGroup">Current Group</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">Operand</Typography>
          <OperandInput 
            operand={{ ...selectedNode.operand }} 
            updateOperand={(newOperand) => updateNodeData(undefined, undefined, newOperand)} 
            attributes={props.attributes} 
            nodeType={'formula'} 
            canDelete={false}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

const DEFAULT_OPERAND = {value: "", attribute: "", formula: "", inputAttribute: "", type: "manual"};

function ConditionForm(props) {
  const { selectedNode, setSelectedNode } = useContext(CalculationVisualizerContext);

  const updateNodeData = (selectedCondition, operands) => {
    const tempNodeData = { ...selectedNode };

    tempNodeData.condition = {
      ...tempNodeData.condition,
      operator: selectedCondition || tempNodeData.condition?.operator || "",
      operands: operands || tempNodeData.condition?.operands || [],
    };

    setSelectedNode({ ...tempNodeData });
  };

  return (
    <Grid item xs={12}>
      <Typography variant="h6" style={{ marginTop: "10px" }}>Condition Details</Typography>
      <Grid container spacing={2} style={{ marginTop: "10px", border: "2px solid #00000017", borderRadius: "5px" }}>
        <Grid item xs={12}>
          <FormControl fullWidth size="small" variant="filled">
            <InputLabel shrink id="option-list-label">Selected Condition</InputLabel>
            <Select
              value={selectedNode.condition?.operator || ""}
              displayEmpty
              id="option-list-label"
              onChange={(e) => updateNodeData(e.target.value)}
            >
              <MenuItem value="" disabled>Please select one of the following</MenuItem>
              <MenuItem value="find">Find</MenuItem>
              <MenuItem value="<">Less Than</MenuItem>
              <MenuItem value=">">Greater Than</MenuItem>
              <MenuItem value="=">Equals</MenuItem>
              <MenuItem value="!=">Not Equals</MenuItem>
              <MenuItem value="greatestValue">Greatest Value</MenuItem>
              <MenuItem value="lowestValue">Lowest Value</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}> 
          <Typography variant="h6" style={{ marginTop: "10px" }}>Operand List (In Order)</Typography>
          <div style={{ padding: "0px 10px", overflowX: "hidden", overflowY: "auto", maxHeight: "400px" }}>
            {selectedNode.condition?.operands?.map((o, i) => {
              return (
                <OperandInput 
                  key={'operand-' + i} 
                  operand={{ ...o }} 
                  updateOperand={(newOperand) => {
                    const newOperandList = [...selectedNode.condition?.operands];
                    newOperandList.splice(i, 1, newOperand);
                    updateNodeData(undefined, newOperandList);
                  }} 
                  deleteOperand={() => {
                    const newOperandList = [...selectedNode.condition?.operands];
                    newOperandList.splice(i, 1);
                    updateNodeData(undefined, newOperandList);
                  }}
                  canDelete={selectedNode.condition?.operands?.length > 1}
                  attributes={props.attributes} 
                  nodeType={'condition'} 
                />
              )
            })}
          </div>
          <Button 
            variant="contained" 
            fullWidth 
            style={{ marginTop: "10px" }} 
            onClick={() => updateNodeData(undefined, [...selectedNode.condition?.operands, DEFAULT_OPERAND])}
          >
            Add Operand
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default function EditNodeModal (props) {
  const { graph, setRefreshGraph, selectedNode, setSelectedNode, isEditNodeModalOpen, setIsEditNodeModalOpen } = useContext(CalculationVisualizerContext);
  const [attributes, setAttributes] = useState([]);

  const updateNodeData = (label, selectedGroup, selectedNodeType) => {
    const tempNodeData = { ...selectedNode };

    if (selectedNodeType && selectedNodeType === "formula") {
      delete tempNodeData.condition;
    } else if (selectedNodeType && selectedNodeType === "condition") {
      delete tempNodeData.formula;
      delete tempNodeData.attribute;
      delete tempNodeData.inputAttribute;
    }

    tempNodeData.label = label ?? tempNodeData.label ?? "";
    tempNodeData.group = selectedGroup || tempNodeData.group || "";
    tempNodeData.nodeType = selectedNodeType || tempNodeData.nodeType || "formula";

    setSelectedNode({ ...tempNodeData });
  };

  const updateNode = async () => {
    const newNode = {
      group: selectedNode.group,
      label: selectedNode.label,
    }

    if (selectedNode.nodeType === "formula") {
      newNode.formula = selectedNode.formula;
      newNode.value = selectedNode.operand.value ? Number(selectedNode.operand.value) : undefined;
      newNode.attribute = selectedNode.operand.attribute;
      newNode.inputAttribute = selectedNode.operand.inputAttribute;
      newNode.next = selectedNode.next;
    } else {
      const operands = selectedNode.condition.operands?.map(o => {
        const value = o.value && !isNaN(Number(o.value)) ? Number(o.value) : o.value || undefined;

        return {
          value,
          attribute: o.attribute,
          inputAttribute: o.inputAttribute,
          formula: o.formula,
          next: o.next || selectedNode.condition.default.next || null,
        }
      });

      newNode.condition = {
        operator: selectedNode.condition.operator,
        default: {
          next: selectedNode.condition.default.next,
        },
        operands: [ ...operands ],
      };
    }

    await setCustomCalculations(JSON.stringify({
      ...graph,
      [selectedNode.id]: newNode,
    }));

    setRefreshGraph(true);
    setIsEditNodeModalOpen(false);
    setSelectedNode(null);
  }

  useEffect(() => {
    async function getData() {
      await getOptionAttributes().then(result => {
        setAttributes(result.data.attributes);
      }).catch(err => {
        setAttributes([]);
      });
    }

    getData();

    updateNodeData(undefined, undefined, selectedNode?.condition ? "condition" : "formula");
  }, []);

  return (
    <Dialog open={isEditNodeModalOpen} onClose={() => setIsEditNodeModalOpen(false)} maxWidth="sm" fullWidth>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                Edit Node
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Node Label"
                fullWidth
                size="small"
                value={selectedNode.label ?? "" }
                onChange={(e) => updateNodeData(e.target.value, undefined, undefined)}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth size="small" variant="filled">
                <InputLabel shrink id="option-list-label">Selected Group</InputLabel>
                <Select
                  value={selectedNode.group ?? ""}
                  displayEmpty
                  id="option-list-label"
                  onChange={(e) => updateNodeData(undefined, e.target.value, undefined)}
                >
                  <MenuItem value="" disabled>Please select one of the following</MenuItem>
                  <MenuItem value="cost">Cost</MenuItem>
                  <MenuItem value="loadedCost">Loaded Cost</MenuItem>
                  <MenuItem value="price">Price</MenuItem>
                  <MenuItem value="quantity">Quantity</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth size="small" variant="filled">
                <InputLabel shrink id="option-list-label">Selected Node Type</InputLabel>
                <Select
                  value={selectedNode.nodeType ?? ""}
                  displayEmpty
                  id="option-list-label"
                  onChange={(e) => updateNodeData(undefined, undefined, e.target.value)}
                >
                  <MenuItem value="" disabled>Please select one of the following</MenuItem>
                  <MenuItem value="formula">Formula</MenuItem>
                  <MenuItem value="condition">Condition</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {selectedNode.nodeType === 'formula' ? (
              <FormulaForm attributes={attributes} />
            ) : (
              <ConditionForm attributes={attributes} />
            )}

            <Grid item xs={12}>
              <Button onClick={() => updateNode()} variant="contained" style={{ marginTop: "20px", backgroundColor: "#142E3E", color: "#28C4FC" }}>
                Update Node
              </Button>
            </Grid>
          </Grid> 
        </CardContent>
      </Card>
    </Dialog>
  );
}